import { useQuery } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useFetchClientesProductsUsers() {
  const token = useAccessToken()
  return useQuery({
    queryKey: ['productClientsUsers'],
    queryFn: async () => {
      const response = await api.get(`/products/clientsProductUsers`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      if (response.data && response.data.data) {
        return response.data.data
      } else {
        throw new Error('Data não encontrado no resultado')
      }
    }
  })
}
